
<div class="ms-1 pt-1 pt-lg-0 text-center" >
    <a href="javascript:void(0)" (click)="helpersService.goToHomeLang()" class="ls-p-extra-small underlined text-neutral-A1">
        Home 
    </a>
    <span class="ls-p-extra-small"> / </span>
    <span class="ls-p-extra-small text-neutral-50">Cookie Policy</span>
</div>
<div class="w-100 d-flex justify-content-center align-items-center">
<h1 class="ls-h1-page-title text-brand-10 text-start text-sm-center px-3 px-sm-0 mt-4">Cookie Policy</h1>        
</div>    
<div class="container-row">
    <div class="d-flex flex-wrap container ">
        <div class="col-12 col-md-12 ">
            <div class="marginBottom">
                <div id="body-cookie" class="col-12 col-md-9 m-auto mb-5 paragraph">
                </div>
            </div>
        </div>
    </div>
</div>